import { combineReducers } from 'redux';

export function error(state = null, action) {
  switch (action.type) {
    case 'JOB_VIEW_PAGE_ERROR':
      return action.error;

    case 'JOB_VIEW_PAGE_RESET':
      return null;

    default:
      return state;
  }
}

export function loading(state = false, action) {
  switch (action.type) {
    case 'JOB_VIEW_PAGE_LOADING':
      return action.loading;

    case 'JOB_VIEW_PAGE_RESET':
      return false;

    default:
      return state;
  }
}

export function retrieved(state = null, action) {
  switch (action.type) {
    case 'JOB_VIEW_PAGE_SUCCESS':
      return action.retrieved;

    case 'JOB_VIEW_PAGE_RESET':
      return null;

    default:
      return state;
  }
}

export default combineReducers({ error, loading, retrieved });
